module.exports = __webpack_public_path__ + "static/media/historic_call_marker.eed8d8fe.svg";